module.exports = __webpack_public_path__ + "static/hero_video_poster-c7ced16c4157a43fbc5613948ab16a75.jpg";